import {
    LOGIN_USER_PENDING,
    LOGIN_USER_FULFILLED,
    LOGIN_USER_REJECTED,
    LOGOUT_USER_REJECTED,
    LOGOUT_USER_FULFILLED,
    LOGOUT_USER_PENDING,
    CHECK_SSO_PENDING,
    CHECK_SSO_FULFILLED,
    CHECK_SSO_REJECTED
} from '../actions/UserActions';

// INITIALIZE STATE
const initialState = {
    user: {},
    companyID: '',
    companyName: '',
    userEmail: '',
    loggedIn: false,
    loggingIn: false,
    loggingOut: false,
    shouldUseSSO: true,
    checkingSSOPending: false,
    checkingSSOFulfilled: false,
    checkingSSOFailed: false,
    message: '',
    failed: false,
};

// REDUCER
export const UserReducer = (state = initialState, action) => {
    switch(action.type) {
        case LOGIN_USER_PENDING:
            return {
                ...state,
                loggingIn: true,
                loggedIn: false,
                failed: false,
                message: '',
            };
        case LOGIN_USER_FULFILLED: {
            localStorage.setItem('companyID', action.payload.companyID);
            return {
                ...state,
                user: action.payload.user,
                companyID: action.payload.companyID,
                companyName: action.payload.companyName,
                userEmail: action.payload.userEmail,
                loggedIn: true,
                loggingIn: false,
                failed: false,
                message: '',
            };
        }
        case LOGIN_USER_REJECTED:
            return {
                ...state,
                loggedIn: false,
                loggingIn: false,
                failed: true,
                message: action.payload.message,
            };
        case LOGOUT_USER_PENDING: {
            localStorage.removeItem('companyID');
            return {
                ...state,
                loggingOut: true,
                failed: false,
                message: '',
            };
        }
        case LOGOUT_USER_FULFILLED:
            return {
                ...state,
                user: {},
                companyID: '',
                loggingOut: false,
                loggedIn: false,
                failed: false,
                message: '',
                checkingSSOFulfilled: false,
            };
        case LOGOUT_USER_REJECTED:
            return {
                ...state,
                loggingOut: false,
                message: action.payload.message,
                failed: true,
            };
        case CHECK_SSO_PENDING:
            return {
                ...state,
                checkingSSOPending: true,
                checkingSSOFulfilled: false,
                checkingSSOFailed: false
            };
        case CHECK_SSO_FULFILLED:
            return {
                ...state,
                shouldUseSSO: action.payload,
                checkingSSOPending: false,
                checkingSSOFulfilled: true,
                checkingSSOFailed: false
            };
        case CHECK_SSO_REJECTED:
            return {
                ...state,
                shouldUseSSO: action.payload,
                checkingSSOPending: false,
                checkingSSOFulfilled: false,
                checkingSSOFailed: true
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/components/state/reducers/UserReducer.js